import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setBreadCrumb } from "shared/redux/reducers/breadCrumbSlice";
import { findScreenTitle } from "shared/utils/helper";
import { routeConstant } from "shared/routes/routeConstant";
import { Icons } from "assets";
import classNames from "classnames";
import BreadCrumb from "../../common/breadCrumb";
import CustomNotificationButton from "../../common/customNotificationButton";
import styles from "./style.module.scss";
import useNotificationCount from "shared/hooks/useNotificationCount";

function DashboardHeader() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { count: notificationCount } = useNotificationCount();

  useEffect(() => {
    const currentTitle = findScreenTitle(location.pathname);

    dispatch(
      setBreadCrumb({
        crumbs: [
          {
            title: currentTitle,
          },
        ],
        prePath: location.pathname,
      }),
    );
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <div className={classNames(styles.topLevelContainer)}>
      <div className={classNames("w-full", styles.headerContainer)}>
        <div className={classNames("flex items-center gap-2")}>
          <BreadCrumb />
        </div>

        <div>
          <CustomNotificationButton
            Icon={<Icons.Bell />}
            count={notificationCount}
            to={
              location.pathname.includes("/client")
                ? routeConstant.client.notifications.path
                : location.pathname.includes("/collaborator")
                  ? routeConstant.collaborator.notifications.path
                  : location.pathname.includes("/builder")
                    ? routeConstant.builder.notifications.path
                    : routeConstant.designer.notifications.path
            }
          />
        </div>
      </div>
    </div>
  );
}

export default DashboardHeader;
